import React, { useState } from 'react';

export function AIChatWidget({ onStartAIRefinement, isRefining, showAIRefinement }) {
  return (
    <div className="sidebar-widget ai-chat-widget">
      <h3 className="widget-title">AI Assistant</h3>
      <div className="ai-widget-placeholder">
        <p>Need help finding the perfect schools?</p>
        <button
          className="start-ai-chat-btn"
          onClick={onStartAIRefinement}
          disabled={isRefining}
        >
          {isRefining ? 'Starting...' : showAIRefinement ? 'Open AI Chat' : 'Start AI Chat'}
        </button>
        {showAIRefinement && (
          <p className="ai-chat-active-note">AI Chat is ready! Click to open.</p>
        )}
      </div>
    </div>
  );
}

export function SaveReportWidget({ onSaveEmail }) {
  const [email, setEmail] = useState('');
  const [isSavingEmail, setIsSavingEmail] = useState(false);

  const handleSaveEmail = async (e) => {
    e.preventDefault();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      alert('Please enter a valid email address');
      return;
    }

    setIsSavingEmail(true);
    const success = await onSaveEmail(email);
    setIsSavingEmail(false);

    if (success) {
      alert('Email saved! You will receive a link to this report shortly.');
    } else {
      alert('Failed to save email. Please try again.');
    }
  };

  return (
    <div className="sidebar-widget save-report-widget">
      <h3 className="widget-title">Unlock Your Full Report</h3>
      <p className="widget-description">
        Get your PDF report and personalized next steps for your college journey
      </p>
      <form onSubmit={handleSaveEmail} className="widget-form">
        <input
          type="email"
          placeholder="your.email@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="widget-input"
          required
        />
        <button
          type="submit"
          className="widget-submit-btn"
          disabled={isSavingEmail}
        >
          {isSavingEmail ? 'Saving...' : 'Get PDF & Next Steps'}
        </button>
      </form>
    </div>
  );
}

export function CTAWidget() {
  return (
    <div className="sidebar-widget cta-widget">
      <h3 className="widget-title">Maximize Your Chances</h3>
      <p className="widget-description">
        Get expert guidance from an admissions consultant
      </p>
      <div className="widget-cta-actions">
        <a href="tel:+18668115177" className="widget-cta-btn primary">
          Call: (866) 811-5177
        </a>
        <a
          href="https://www.prepscholar.com/college-admissions-consulting/"
          target="_blank"
          rel="noopener noreferrer"
          className="widget-cta-btn secondary"
        >
          Learn More →
        </a>
      </div>
    </div>
  );
}